import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import RawDataView from "@/features/R1Dashboard/views/RawDataView";

export default function R1RawData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Raw Data");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <RawDataView />
      </main>
    </R1DashboardProvider>
  );
}
